module.exports = __webpack_public_path__ + "static/FunktionalGrotesk-Light-2a17ff67460997b0debb299eaa38269f.woff";